class ProductComparison extends HTMLElement {
  #resizeObserver;
  #resizeTimeout;

  connectedCallback() {
    this.#observeTable();
    this.#syncHeights();
    this.setAttribute('data-init', 'true');
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    clearTimeout(this.#resizeTimeout);
  }

  #syncHeights() {
    this.#resizeObserver?.disconnect();

    this.#syncGroup(this.querySelectorAll('[data-product-comparison="header"]'));
    this.#syncGroupsByAttribute('data-product-comparison-row');

    this.#observeTable();
  }

  #syncGroup(elements) {
    if (elements.length === 0) return;

    elements.forEach((element) => {
      element.style.minHeight = '';
    });

    void elements[0].offsetHeight;

    const maxHeight = Math.max(
      ...Array.from(elements, (element) => Math.ceil(element.scrollHeight))
    );

    elements.forEach((element) => {
      element.style.minHeight = `${maxHeight}px`;
    });
  }

  #syncGroupsByAttribute(attribute) {
    const groups = new Map();

    this.querySelectorAll(`[${attribute}]`).forEach((element) => {
      const key = element.getAttribute(attribute);
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key).push(element);
    });

    if (groups.size === 0) return;

    const allElements = Array.from(groups.values()).flat();

    allElements.forEach((element) => {
      element.style.minHeight = '';
    });

    void allElements[0].offsetHeight;

    const measurements = new Map();

    groups.forEach((groupElements, key) => {
      const maxHeight = Math.max(
        ...groupElements.map((element) => Math.ceil(element.scrollHeight))
      );
      measurements.set(key, maxHeight);
    });

    groups.forEach((groupElements, key) => {
      const maxHeight = measurements.get(key);

      groupElements.forEach((element) => {
        element.style.minHeight = `${maxHeight}px`;
      });
    });
  }

  #observeTable() {
    if (!window.ResizeObserver) return;

    this.#resizeObserver?.disconnect();

    this.#resizeObserver = new ResizeObserver(() => {
      clearTimeout(this.#resizeTimeout);
      this.#resizeTimeout = setTimeout(() => {
        this.#syncHeights();
      }, 100);
    });

    const tableContainer = this.querySelector('.comparison-table');
    if (tableContainer) {
      this.#resizeObserver.observe(tableContainer);
    }
  }
}

customElements.define('product-comparison', ProductComparison);
